{
	"errorPage.404.button": "Zurück zur Startseite",
	"errorPage.404.code": "404 Fehler",
	"errorPage.404.description": "Die gesuchte Seite existiert leider nicht oder wurde verschoben.",
	"errorPage.404.title": "Seite nicht gefunden...",
	"errorPage.network.description": "Die Seite konnte nicht geladen werden.\nÜberprüfe die Interneteinstellungen und versuch es noch einmal.",
	"errorPage.network.title": "Es ist ein Fehler aufgetreten…",
	"global.refreshButton": "Aktualisieren",
	"global.toast.error.message": "Es ist ein Fehler aufgetreten. Bitte versuch es noch einmal.",
	"global.toast.error.title": "Fehler"
}
